import React from 'react'

const KeyedCipherAlgo = () => {
    return (
        <div>
            <h3>Encryption:</h3>
            <ol>
                <li>Take the plaintext message you want to encrypt.</li>
                <li>Write down the key for encryption, which has to be a sequence of integers.</li>
                <li>If the key is shorter than the plain text, repeat the key until it covers the entire plain text.<span style={{ fontWeight: "bold", color: "blue" }}>(For example, if the key is "2401" and the plain text is "VIDYALANKAR," you would write "24012401240" assigning a number to each letter.)</span></li>
                <li>Sort the key you created in step 2, including repeated numbers.<span style={{ fontWeight: "bold", color: "blue" }}>(For instance, if the key is "24012401240," after sorting it becomes "00011222444.)</span></li>
                <li>Now, look at the sorted key. For each number in the sorted key, find its first occurrence in the unsorted key created in step 2. The letter corresponding to that position in the unsorted key will be your cipher letter.</li>
                <li>Repeat this process for all the letters in the plain text to obtain your cipher text.<span style={{ fontWeight: "bold", color: "blue" }}>(Therefore, Cipher text = DARYNVAKILA)</span></li>
                <li>The resulting ciphertext is the encrypted message.</li>
            </ol>
            <br />
            <h3>Decryption:</h3>
            <ol>
                <li>Take the ciphertext you want to decrypt.</li>
                <li>Write the same sorted key that was used for encryption in step 3.<span style={{ fontWeight: "bold", color: "blue" }}>(Sorted Key = 00011222444)</span></li>
                <li>Write the unsorted key i.e the original key sequence written for the plaintext for encryption in step 2.<span style={{ fontWeight: "bold", color: "blue" }}>(Key = 24012401240)</span></li>
                <li>Look at the original key sequence. For each number in the key sequence, find its first occurrence in the sorted key. The letter corresponding to that position in the cipher text will be your decrypted letter.</li>
                <li>Repeat this process for all the letters in the cipher text to obtain the original plaintext message.<span style={{ fontWeight: "bold", color: "blue" }}>(Therefore, Plain text = VIDYALANKAR)</span></li>
                <li>The resulting plaintext is the decrypted message.</li>
            </ol>
        </div>

    )
}

export default KeyedCipherAlgo